<template>
  <header
    v-if="usedVariant !== 'no-header'"
    v-bind="$attrs"
    class="the-header flex flex-col pb-300 pt-200 gap-200"
  >
    <div class="content-wrap flex justify-between px-100">
      <section class="flex items-center">
        <HyperLink to="/">
          <img
            :alt="shopPublicName"
            :height="32"
            src="~/assets/img/brand/logo-default.svg"
            :width="204"
          />
        </HyperLink>
      </section>

      <section v-if="usedVariant !== 'logo-only'" class="flex items-center gap-200">
        <ClientOnly>
          <RichInboxButton v-if="showRichInbox" />
        </ClientOnly>
        <TheHeaderStateSwitch :icon-only="isRichInboxEnabled" />
      </section>
    </div>
  </header>
  <ActiveAnnouncement class="content-wrap px-100 mb-200" />
</template>

<script lang="ts" setup>
import type { TheHeaderVariant } from './types'

type TheHeaderProps = {
  variant?: TheHeaderVariant
}

const { variant = undefined } = defineProps<TheHeaderProps>()

const isRichInboxEnabled = useIsFeatureFlagEnabled('richInbox')

const { isLoggedIn } = useAuth()
const { currentRoute } = useRouter()

const {
  i18nConfig: { shopPublicName },
} = useRuntimeConfig().public

const showRichInbox = computed(() => isRichInboxEnabled && isLoggedIn.value)

const usedVariant = computed(() => {
  let { header } = currentRoute.value.meta
  if (typeof variant !== 'undefined') header = variant

  if (typeof header === 'undefined') return 'logo-only'
  if (!header) return 'no-header'
  return header
})
</script>

<style lang="scss" scoped>
.the-header {
  a {
    position: relative;
    display: block;

    @include focus-state {
      &::before {
        inset: -#{token('size/border/200')};
        border-radius: token('size/radius/s');
        box-shadow: 0 0 0 token('size/border/200') token('color/border/accent/focused/focused');
      }
    }
  }
}
</style>
